import { PhaseLayout } from "../../components/PhaseLayout";
import { StepGenerator } from "../../components/StepGenerator";

const STEPS = [
  {
    type: "vision_statement",
    title: "Vision Statement",
    description: "Craft a clear, inspiring vision that guides your business direction.",
    fields: [
      { key: "business_name", label: "Business Name", placeholder: "Your business or brand name", required: true },
      { key: "niche", label: "Industry / Niche", placeholder: "e.g., Health coaching for busy moms", required: true },
      { key: "core_values", label: "Core Values", placeholder: "e.g., Authenticity, simplicity, sustainability", required: true, type: "textarea", hint: "What principles guide your work?" },
      { key: "impact", label: "Long-term Impact", placeholder: "e.g., Help 1000 women build sustainable income", required: true, type: "textarea", hint: "What change do you want to create in the world?" }
    ]
  },
  {
    type: "ideal_client",
    title: "Ideal Client Profile",
    description: "Define exactly who you serve for magnetic messaging.",
    fields: [
      { key: "business_type", label: "Your Business Type", placeholder: "e.g., Digital course creator, coach, consultant", required: true },
      { key: "problem_solved", label: "Problem You Solve", placeholder: "e.g., Help overwhelmed entrepreneurs systemize their business", required: true, type: "textarea" },
      { key: "demographics", label: "Client Demographics", placeholder: "e.g., Women 30-45, service providers, earning $50k-$150k", required: true },
      { key: "aspirations", label: "Client Aspirations", placeholder: "e.g., Financial freedom, more family time, location independence", required: true, type: "textarea" }
    ]
  },
  {
    type: "core_offer",
    title: "Core Offer Definition",
    description: "Clarify your signature offer with precision and purpose.",
    fields: [
      { key: "expertise", label: "Your Expertise", placeholder: "e.g., 10 years in marketing, certified coach, MBA", required: true, type: "textarea" },
      { key: "transformation", label: "Transformation Promised", placeholder: "e.g., From scattered to systemized in 30 days", required: true },
      { key: "format", label: "Delivery Format", placeholder: "e.g., 6-week course, 1:1 coaching, membership", required: true },
      { key: "time_investment", label: "Time Investment Required", placeholder: "e.g., 2 hours/week for 6 weeks", required: true }
    ]
  },
  {
    type: "revenue_mapping",
    title: "Revenue Goal Mapping",
    description: "Create a realistic path to your income goals.",
    fields: [
      { key: "income_goal", label: "Monthly Income Goal", placeholder: "e.g., $10,000/month", required: true },
      { key: "price_point", label: "Product Price Point", placeholder: "e.g., $497 course, $2000 coaching package", required: true },
      { key: "audience_size", label: "Current Audience Size", placeholder: "e.g., 500 email subscribers, 2000 Instagram followers", required: true },
      { key: "time_available", label: "Weekly Hours Available", placeholder: "e.g., 15-20 hours/week", required: true }
    ]
  }
];

export default function ClarityPhase() {
  return (
    <PhaseLayout 
      phaseNumber={1}
      phaseName="Clarity"
      phaseSubtitle="Define Your Foundation"
      phaseDescription="Get crystal clear on your vision, understand your ideal client, and define your core offer. This foundation shapes everything that follows."
      days="Days 1-3"
      nextPhase={{ number: 2, name: "Assets", path: "/phase/assets" }}
      prevPhase={null}
    >
      {STEPS.map((step, index) => (
        <StepGenerator
          key={step.type}
          room="clarity"
          generatorType={step.type}
          stepNumber={index + 1}
          title={step.title}
          description={step.description}
          fields={step.fields}
          defaultOpen={index === 0}
        />
      ))}
    </PhaseLayout>
  );
}
